import { connect } from 'react-redux';
import EditAuction from 'components/auctions/EditAuction';
import {
  clearEditAuction,
  editAuction,
  fetchAuction,
} from 'data/auctions/Auctions.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = state =>
  ReduxHelper.mapStateWithLookups(
    {
      lang: state.i18n.locale,
      auction: state.auctions.currentAuction,
      editingAuction: state.auctions.editingAuction,
      auctionEdited: state.auctions.auctionEdited,
      editError: state.auctions.editError,
      user: state.app.user,
      party: state.app.userParty,
    },
    state,
    'countries',
    'insurances',
    'fuelTypes',
    'vehicleTypes',
    'gearBoxes',
    'wheelDrives',
    'experts',
    'partTypes',
    'partyTypes',
    'auctionStatuses',
    'regions',
    'bidFileTypes',
    'imitationPartCategories',
    'usedConditionTypes',
    'cancellationReasons',
    'applications',
    'memberships'
  );

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchAuction: () => dispatch(fetchAuction(ownProps.params.id)),
  onClearEditAuction: () => dispatch(clearEditAuction()),
  onEdit: (auctionData, folderData) =>
    dispatch(editAuction(auctionData, folderData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAuction);
